import React, { useState } from "react";
import { InputProps } from "antd";
import InputMask from "antd-mask-input";
import { CODE_DIVISION_MASK } from "../../constants/inputMasks";

const UI_ITOCodeDivisionInput = (props: InputProps) => {
  const { onChange, value, size } = props;
  const [inputValue, setInputValue] = useState(value ? String(value) : "");

  const handleInputChange: InputProps['onChange'] = (e) => {
    setInputValue(e.target.value);
    onChange && onChange(e);
  };

  return (
    <InputMask
      size={size}
      mask={CODE_DIVISION_MASK}
      placeholder=""
      value={inputValue}
      onChange={handleInputChange}
    />
  );
};

export default UI_ITOCodeDivisionInput;
